import React, { useEffect } from 'react';
import { SVGBooking } from '../../../../assets/icons/SVGBooking';
import { SVGRestart } from '../../../../assets/icons/SVGRestart';
import { SelfTestResultProps } from '../../../../components/self-test/model/SelfTestResultProps';
import './self-test-result.scss';
import { UrlService } from '../../../../core/services/UrlService';
import { result } from '../data/result';
import { TrackingService } from '../../../../core/services/TrackingService';
// type Props = {
//     // title: string;
//     // content: string;
//     image?: string;
//     onReset: (answer?: string) => any;
// }

const AdpkdSelfTestResult: React.FC<SelfTestResultProps> = (props: SelfTestResultProps) => {
    const handleResetClick = (ev: any) => {
        props.onReset();
    }

    const [parentRisk, setParentRisk] = React.useState<boolean>(false);
    const [risk, setRisk] = React.useState<number>(0);

    useEffect(() => {
        const r = result(props.answers);
        setParentRisk(r.parent_risk);
        setRisk(r.risk);
    }, [props.answers])

    const defaultItmQuery = {
        itm_source: `self-tests_risk-${risk ? 'high' : 'low'}_parent-${parentRisk ? 'high' : 'low'}`,
        itm_medium: 'srp_button',
        itm_campaign: props.questions.analytics.slug,
    };

    const handleSRPButtonClick = () => {
        TrackingService.trackSelftest(props.questions.analytics.slug, `srp`, props.questions.analytics.resultText(props.answers));
    };

    return (
        <div id='result' className="self-test__test-result">
            <div className="self-test__test-result-sizer">
                <div className="self-test__test-result-cover">
                    {!(risk === 0 && !parentRisk) && <img src={UrlService.getLocalImageUrl('self-test/adpkd/result_bad.png')} alt="" />}
                    {risk === 0 && !parentRisk && <img src={UrlService.getLocalImageUrl('self-test/adpkd/result_good.png')} alt="" />}
                </div>
                <div className="self-test__test-result-content">
                    <div className="self-test__test-result-content-top">
                        <div className="self-test__test-result-content-container">
                            <div className="title">
                                評分機制及結果:
                            </div>
                            <div className="subtitle">
                                {risk === 0 && !parentRisk && '根據您的回答，您並沒有出現多囊腎病患者可能出現的病徵。'}
                                {risk === 0 && parentRisk && '根據您的回答，雖然您並沒有出現多囊腎病患者可能出現的病徵，但因您的父／母患有多囊腎病，所以您亦有一定風險患上此病。'}
                                {risk !== 0 && !parentRisk && `根據您的回答，6 項多囊腎病患者可能出現的病徵中，您出現了 ${risk} 項。`}
                                {risk !== 0 && parentRisk && `根據您的回答，6 項多囊腎病患者可能出現的病徵中，您出現了 ${risk} 項。加上您的父／母患有多囊腎病，代表您有一定風險患上此病，需要多注意！`}
                            </div>
                            <div className="description">
                                <br></br>

                                {parentRisk &&
                                    <span>
                                        約有90％多囊腎病病例屬於常染色體顯性多囊性腎臟病（ADPKD)，
                                        只要父母任何一方患病，便有50％機會會遺傳給子女<sup>6</sup>。
                                    </span>
                                }
                                {
                                    !parentRisk &&
                                    <span>
                                        多囊腎病可以十分嚴重，有機會引發中風、二尖瓣脫垂、顱內腦動脈瘤等可致命的併發症<sup>2</sup>。
                                        嚴重患者更有機會出現末期腎衰竭，若沒有透析治療（洗腎）或腎臟移植，則可導致死亡<sup>7</sup>。
                                    </span>
                                }

                                <br></br>
                                <br></br>

                                {
                                    (risk !== 0 || parentRisk) &&
                                    <span>
                                        此病沒有根治方法，但可透過藥物控制病情。
                                        當中，口服抗利尿激素受體拮抗藥物（俗稱「排水劑」）可幫助ADPKD成年患者減緩疾病惡化。
                                        排水劑有效減慢腎臟因囊腫而擴大的速度，延緩腎功能衰退<sup>1</sup>。
                                        <br></br>
                                        <br></br>

                                        擔心多囊腎病影響您的生活，或想了解適合您的治療方法？
                                        立即網上預約專科醫生，尋求專業協助。
                                    </span>

                                }
                                {
                                    risk === 0 && !parentRisk &&
                                    <span>
                                        雖然您沒有出現多囊腎病患者可能出現的病徵，但仍需注意自己的健康狀況。
                                        您可向醫生查詢，了解更多多囊腎病的資訊。
                                        <br></br>
                                        <br></br>

                                        立即網上預約專科醫生，尋求專業協助。
                                    </span>
                                }

                                <br></br>
                            </div>
                            <div className="self-test__test-result-content-container-buttons">
                                <a className="self-test__button primary" target='_blank' href={TrackingService.getNavigateUrlWithITMQuery('https://www.finddoc.com/doctors/adpkd', defaultItmQuery)} rel="noreferrer" onClick={handleSRPButtonClick}>
                                    <SVGBooking /> &nbsp; 預約腎病科醫生
                                </a>
                                <button className="self-test__button secondary" onClick={handleResetClick}>
                                    <SVGRestart /> &nbsp; 重新評估
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdpkdSelfTestResult;
